export const SvgNotesQuestionmark = ({ className }: { className: string }) => {
  return (
    <svg
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <title>Question mark</title>
      <path
        d="M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 33.5c8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5C9.44 2.5 2.5 9.44 2.5 18c0 8.56 6.94 15.5 15.5 15.5zm0 2.5c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.44 12.2c-2.207 0-3.83.99-4.358 2.036a1.1 1.1 0 01-1.964-.992C12.144 11.214 14.716 10 17.44 10c1.761 0 3.403.498 4.634 1.359 1.227.858 2.127 2.15 2.127 3.701 0 2.636-2.49 4.442-5.16 4.92a.797.797 0 00-.412.2c-.081.08-.089.135-.089.16a1.1 1.1 0 01-2.2 0c0-1.433 1.21-2.328 2.314-2.526C20.875 17.416 22 16.12 22 15.06c0-.636-.367-1.324-1.188-1.899-.818-.572-2.007-.96-3.373-.96zm-1.1 12.1a1.1 1.1 0 011.1-1.1h.013a1.1 1.1 0 010 2.2h-.014a1.1 1.1 0 01-1.1-1.1z"
        fill="#fff"
      />
    </svg>
  )
}
